import { gql } from "@apollo/client";

export const GET_FRESHDESK_TCKETS = gql`
  query GreyTHRSupportTickets(
    $startRow: Int
    $endRow: Int
    $startDate: String
    $endDate: String
    $status: Int
    $requesterId: String
    $sorting: ticketSortModel
    $clientDomain: String
  ) {
    greyTHRSupportTickets(
      startRow: $startRow
      endRow: $endRow
      startDate: $startDate
      endDate: $endDate
      status: $status
      requesterId: $requesterId
      sorting: $sorting
      clientDomain: $clientDomain
    ) {
      data {
        id
        requester_id
        responder_id
        requester {
          name
          email
        }
        responder {
          name
          email
        }
        subject
        description
        description_text
        created_at
        updated_at
        status
        client {
          id
          name
          client_code
          url
        }
        custom_fields {
          cf_customer_name
          cf_domain_name949839
        }
        haveAccess
      }
      total
    }
  }
`;

export const GET_FRESHDESK_COUNT = gql`
  query GreyTHRTicketsCounts($startDate: String, $endDate: String) {
    greyTHRTicketsCounts(startDate: $startDate, endDate: $endDate) {
      total
      open
      onHold
      resolved
      closed
      pending
    }
  }
`;

export const GET_FRESHDESK_TICKET_DETAILS = gql`
  query ViewGreyTHRTicket($ticketId: String) {
    viewGreyTHRTicket(ticketId: $ticketId) {
      id
      requester_id
      responder_id
      source
      type
      requester {
        name
        email
      }
      responder {
        name
        email
      }
      subject
      description
      description_text
      created_at
      updated_at
      due_by
      fr_due_by
      is_escalated
      association_type
      status
      client {
        id
        name
        client_code
        url
      }
      custom_fields {
        cf_customer_name
        cf_domain_name949839
        category
        cf_query_type945824
        cf_query_sub_category6723
        cf_query_categorymodule319717
      }
      conversations {
        body_text
        body
        id
        incoming
        private
        user_id
        support_email
        source
        ticket_id
        created_at
        updated_at
        from_email
        last_edited_at
        last_edited_user_id
        user_details {
          name
          email
        }
        attachments {
          id
          content_type
          size
          name
          attachment_url
          created_at
          updated_at
        }
      }
      attachments {
        id
        content_type
        size
        name
        attachment_url
        created_at
        updated_at
      }
    }
  }
`;

export const GET_USER_OR_CLIENTWISE_LIST = gql`
 query GreyTHRClientTicketsCounts($startRow: Int, $endRow: Int, $startDate: String, $endDate: String, $filterModel: FilterModel) {
  greyTHRClientTicketsCounts(startRow: $startRow, endRow: $endRow, startDate: $startDate, endDate: $endDate, filterModel: $filterModel) {
    data {
      client {
        id
        name
        client_code
        url
      }
      open
      onHold
      resolved
      closed
      total
      pending
    }
    total
  }
}
`;

export const GET_USER_WISE_LIST = gql`
 query GreyTHRUsersTicketsCounts($startRow: Int, $endRow: Int, $startDate: String, $endDate: String, $filterModel: FilterModel) {
  greyTHRUsersTicketsCounts(startRow: $startRow, endRow: $endRow, startDate: $startDate, endDate: $endDate, filterModel: $filterModel) {
    data {
      user {
        id
        name
        email
      }
      open
      onHold
      resolved
      closed
      total
      pending
    }
    total
  }
}

`;
